import { Dispatch } from "redux";
import {
  CustomerGroupPerEmailDispatchTypes,
  CUSTOMER_GROUP_PER_EMAIL_LOADING,
  CUSTOMER_GROUP_PER_EMAIL_FAILURE,
  CUSTOMER_GROUP_PER_EMAIL_SUCCESS,
  CustomerGroupPerEmailFailure,
  CustomerGroupPerEmailSuccess,
} from "./customerGroupPerEmailActionTypes";
import axios from "axios";

export const fetchCustomerGroupPerEmail =
  (email: string) =>
  (dispatch: Dispatch<CustomerGroupPerEmailDispatchTypes>) => {
    dispatch({
      type: CUSTOMER_GROUP_PER_EMAIL_LOADING,
    });

    const encodedEmail = encodeURIComponent(email);

    let url = `https://trailer.stealth-intel.com/api/v1/sunbeltcamera/check/${encodedEmail}`;

    return axios
      .get(
        //"http://localhost:3001/api/v1/emailOrDomain/"
        url
      )
      .then((res) => {
        const data: Array<string> = res.data;
        let success: CustomerGroupPerEmailSuccess = {
          type: CUSTOMER_GROUP_PER_EMAIL_SUCCESS,
          payload: data,
        };
        return success;
      })
      .catch((error) => {
        let failure: CustomerGroupPerEmailFailure = {
          type: CUSTOMER_GROUP_PER_EMAIL_FAILURE,
        };
        return failure;
      });
  };
